import React, { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

type SpinnerProps = ComponentPropsWithoutRef<'div'> & {
  size?: string;
  color?: string;
  thickness?: number;
};

function Spinner({
  size = '4rem',
  color = '#CCC',
  thickness = 4,
  ...rest
}: SpinnerProps) {
  return (
    <Container {...rest}>
      {/* https://reactjsexample.com/a-flashy-material-design-inspired-spinner-using-purely-css/ */}
      <div
        className="react-spinner-material"
        style={{
          width: size,
          height: size,
          borderColor: color,
          borderWidth: `${thickness}px`,
        }}
      />
    </Container>
  );
}

export default Spinner;
